import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay,{attrs:{"id":"LoadingOverlay","opacity":0.3,"value":_vm.is_loading}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"64"}}),_c('p',{staticClass:"mt-2 text-title"},[_vm._v("กำลังโหลด...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }